import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AgentDefinition } from 'app/modules/agent-library/models/agent-definition.model';
import { AgentRunHistoryEntry } from 'app/modules/agent-library/models/agent-run.model';
import { AgentRunStatusMeta } from 'app/modules/agent-library/models/agent-taxonomy.model';
import { AGENT_RUN_STATUS_META } from 'app/modules/agent-library/services/agent-taxonomy.constants';
import { runDateOf } from '../../services/agent-runs.helper';

/**
 * What the Chats tab shows while the assistant is talking to a named agent: that agent's recorded
 * runs, since an agent has no chat threads of its own.
 *
 * Its own component rather than a mode of `<deo-ai-assistant-chats-view>`, because everything that
 * view offers over a chat — search, selection, bulk delete, move to project, starring, artifact
 * counts — needs a backend session, and a run has none. Read-only by construction instead of by
 * suppressing all of it.
 */
@Component({
  selector: 'deo-agent-runs-panel',
  standalone: false,
  templateUrl: './deo-agent-runs-panel.component.html',
  styleUrls: ['./deo-agent-runs-panel.component.scss']
})
export class DeoAgentRunsPanelComponent {
  @Input() agent: AgentDefinition | null = null;

  /** The run whose transcript is open, so its card can be marked. */
  @Input() selectedRunId: string | null = null;

  @Output() runSelected$ = new EventEmitter<AgentRunHistoryEntry>();

  get runs(): AgentRunHistoryEntry[] {
    return this.agent?.runHistory ?? [];
  }

  statusMetaFor(run: AgentRunHistoryEntry): AgentRunStatusMeta {
    return AGENT_RUN_STATUS_META[run.status];
  }

  runDate(run: AgentRunHistoryEntry): string {
    return runDateOf(run);
  }

  onSelectRun(run: AgentRunHistoryEntry): void {
    this.runSelected$.emit(run);
  }

  protected trackByRunId(index: number, run: AgentRunHistoryEntry): string {
    return run.id;
  }
}
